// naive implementation based on design from https://zeroheight.com/7sjjzhgo2/p/138813-animation-library
// will be replaced with Spinner from wix-ui-tpa once implemented there
import React, { type FC } from 'react';
import cn from 'clsx';
import s from './styles.scss';

export const Spinner: FC<{
  size?: 'small' | 'medium';
  color?: 'black' | 'white';
}> = ({ size = 'medium', color = 'black' }) => {
  const edgeSize: number = size === 'small' ? 36 : 54;

  return (
    <svg
      className={s.spinner}
      viewBox={`0 0 ${edgeSize} ${edgeSize}`}
      style={{
        width: edgeSize,
        height: edgeSize,
      }}
    >
      <circle
        className={cn(s.path, s[size])}
        style={{
          stroke: color === 'black' ? '#000' : '#fff',
        }}
        cx={edgeSize / 2}
        cy={edgeSize / 2}
        r={edgeSize / 2 - 3}
        strokeWidth="2"
        fill="none"
      ></circle>
    </svg>
  );
};
Spinner.displayName = 'Spinner';
